import { Injectable } from '@angular/core';
import { LogService } from 'libs/api-client/src/lib/log.service';
import { PtUiAppRoutes } from '@pt/pt-models';

const LATEST_PAGE = 'latestPage';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly logLevel = 'DEBUG';
  // private readonly ignoredSuffixURLs = ['/login'];
  private readonly ignoredSuffixURLs = [
    '/' + PtUiAppRoutes.LOGIN,
    '/' + PtUiAppRoutes.DEBUG,
    '/' + PtUiAppRoutes.LOADER,
    '/' + PtUiAppRoutes.OAUTH,
    '/' + PtUiAppRoutes.FORBIDDEN_MODULE,
    '/' + PtUiAppRoutes.CHANGE_PASSWORD,
    '/' + PtUiAppRoutes.GENERIC_REPORT,
    '/' + PtUiAppRoutes.MFA,
  ];

  constructor(private log: LogService) {}

  private validUrl(url: string): boolean {
    let valid = true;
    this.ignoredSuffixURLs.forEach((suffix) => {
      if (url.endsWith(suffix)) {
        valid = false;
      }
    });
    return valid;
  }
  public setLatestPage(url: string) {
    if (this.validUrl(url)) {
      localStorage.setItem(LATEST_PAGE, url);
      if (this.log.isLoggable(this.logLevel)) {
        console.groupCollapsed('[DEBUG] set latest page ', LATEST_PAGE);
        console.log('url ' + url);
        console.log('caller:', this.getCaller());
        console.groupEnd();
      }
    } else {
      if (this.log.isLoggable(this.logLevel)) {
        console.groupCollapsed('[DEBUG] ignored latest page ', LATEST_PAGE);
        console.log('url ' + url);
        console.log('ignoredSuffixURLs ', this.ignoredSuffixURLs);
        console.log('caller:', this.getCaller());
        console.groupEnd();
      }
    }
  }

  public clearLatestPage() {
    const oldUrl: string | null = this.getLatestPage();
    localStorage.removeItem(LATEST_PAGE);
    if (this.log.isLoggable(this.logLevel)) {
      console.groupCollapsed('[DEBUG] clean latest page ', LATEST_PAGE);
      console.log('removed Url ' + oldUrl);
      console.log('caller:', this.getCaller()); // 👈 AGGIUNTO
      console.groupEnd();
    }
  }

  public getLatestPage(): string | null {
    const url = localStorage.getItem(LATEST_PAGE) ?? null;
    if (this.log.isLoggable(this.logLevel)) {
      console.groupCollapsed('[DEBUG] getLatestPage ', LATEST_PAGE);
      console.log('Url ' + url);
      console.log('caller:', this.getCaller()); // 👈 AGGIUNTO
      console.groupEnd();
    }
    return url;
  }

  /**
   *
   * @param fullClean si potrebbe usare in caso di logout volontario
   */
  public cleanStorage(fullClean = false): void {
    const latestPage: string | null = this.getLatestPage();
    localStorage.clear();
    if (latestPage && !fullClean) {
      this.setLatestPage(latestPage);
    }
    if (this.log.isLoggable(this.logLevel)) {
      console.groupCollapsed('[DEBUG] clean storage');
      console.log('localStorage.clear()');
      if (latestPage) {
        console.log('restore ' + LATEST_PAGE, latestPage);
      } else {
        console.log('missing ' + LATEST_PAGE);
      }
      console.log('caller:', this.getCaller()); // 👈 AGGIUNTO
      console.groupEnd();
    }
  }

  private getCaller(): string {
    const err = new Error();
    const stack = err.stack?.split('\n') ?? [];

    // le prime righe dello stack sono la stessa funzione, partiamo dalla terza
    const callerLine = stack[3] ?? 'caller not found';
    return callerLine.trim();
  }
}
